// TODO: Remove the eslint-disable comment after the file is refactored
/* eslint-disable max-lines */
import { useEffect, useMemo, useState } from 'react'
import { Form, FormSpy } from 'react-final-form'
//import { useHistory } from 'react-router'
import { useQueryClient } from '@tanstack/react-query'
import RouterPromptStay from 'app/router/RouterPromptStay'
import cloneDeep from 'lodash/cloneDeep'
import isEqual from 'lodash/isEqual'

import { parseFieldsConfiguration } from 'common/components/dynamicFields/helpers'
import {
  ConditionalValue,
  FieldType,
} from 'common/components/dynamicFields/interfaces'
import { SelectValue } from 'common/components/singleSelect'
import { successToast } from 'common/components/toastNotification'
import { Topic } from 'common/components/topics/interfaces'
import { useAppDispatch, useAppSelector } from 'common/hooks/redux'
import { isComponentElement } from 'features/unifiedFlow/api/interfaces'
import useGenerateVariantsMutation from 'features/unifiedFlow/api/mutations/useGenerateVariantsMutation'
import useUpdateContentMutation from 'features/unifiedFlow/api/mutations/useUpdateContentMutation'
import {
  toggleElementsDisabled,
  userInputFormHasChanged,
} from 'features/unifiedFlow/store/unifiedFlowSlice'

import {
  getContentHasVariants,
  getElementHasVariants,
  getElementIdForGeneration,
  setVariantsLoadingState,
} from '../../helpers'
import { useContent, useSelectedElement, useTopics } from '../../hooks'
import { getGenerateWsTopic } from '../../hooks/useWebsocketStatus'

import ActionButtons from './bottomActionButtons/ActionButtons'
import BriefTitle from './BriefTitle'
import DynamicForm from './DynamicForm'
import FormLeaveModal from './FormLeaveModal'
import GeneratedBrief from './GeneratedBrief'
import GeneratedTopics from './GeneratedTopics'
import RegenerateModal from './RegenerateModal'

export type FormSubmitAction = (
  formValues: Record<string, ConditionalValue<FieldType> | undefined>
) => Promise<void>
export type PageState =
  | 'formChanged'
  | 'formChangedWithoutTopics'
  | 'topicsChanged'
  | 'generateBrief'
  | 'generateTopics'
  | 'generateVariants'
  | 'showGeneratedContentWithoutTopics'
  | 'showGeneratedContent'
  | 'generateWithoutTopics'
  | 'showTemplateWithoutTopics'
  | 'showTemplate'

const BriefPage = () => {
  // const history = useHistory()
  const dispatch = useAppDispatch()
  const queryClient = useQueryClient()

  const [regenerateModalState, setRegenerateModalState] = useState<{
    isOpen: boolean
    formValues?: Record<string, string | number | string[] | undefined>
  }>({
    isOpen: false,
    formValues: undefined,
  })

  const accountId = useAppSelector((state) => state.authStates.accountId)

  const { content } = useContent()

  const activeContentId = useAppSelector(
    (state) => state.unifiedFlow.activeContentId
  )

  const { data: topics } = useTopics(activeContentId)
  const { data: selectedElement } = useSelectedElement()

  const updateContentMutation = useUpdateContentMutation()
  const generateVariantsMutation = useGenerateVariantsMutation()

  const isGlobalSettings = false // TODO: Fix this variable

  const userInputForm = !isGlobalSettings
    ? selectedElement?.user_input?.user_input_form.filter(
        (field) => field.name !== 'content_name'
      ) ||
      content?.user_input.user_input_form.filter(
        (field) => field.name !== 'content_name'
      )
    : content?.user_input.user_input_form

  const [selectedTopics, setSelectedTopics] = useState<Topic[]>(topics ?? [])
  const [hasFormChanged, setHasFormChanged] = useState(false)

  const shouldUseTopics = content?.requires_ner

  const hasVariants = useMemo(() => {
    if (!isGlobalSettings) {
      return getElementHasVariants(selectedElement)
    } else {
      return getContentHasVariants(content)
    }
  }, [content, selectedElement, isGlobalSettings])

  useEffect(() => {
    const isWaitingForVariants = content?.elements?.some(
      (element) =>
        isComponentElement(element) && element.nlg_status === 'pending'
    )
    if (!isWaitingForVariants) {
      setSelectedTopics(topics ?? [])
    }
  }, [content?.elements, topics])

  const revertTopics = () => {
    setSelectedTopics(topics ?? [])
  }

  const generateTopics: FormSubmitAction = async (formValues) => {
    // if (!template) {
    //   return
    // }
    // const updatedTemplate = cloneDeep(template)
    // updatedTemplate.user_input_form?.forEach((field) => {
    //   if (formValues[field.name] != null) {
    //     field.value = formValues[field.name]
    //   }
    // })
    // const name = updatedTemplate.user_input_form?.find(
    //   (field) => field.name === 'content_name'
    // )?.value as string | undefined
    // updatedTemplate.name = name || ''
    // await createContentMutation.mutateAsync(
    //   { accountId, template: updatedTemplate },
    //   {
    //     onSuccess: (newContent) => {
    //       history.replace(`/content/${newContent._id}`)
    //     },
    //   }
    // )
  }

  const refreshTopics: FormSubmitAction = async (formValues) => {
    if (!content) {
      return
    }

    const userInputForm = cloneDeep(content.user_input.user_input_form)

    userInputForm.forEach((field) => {
      if (formValues[field.name] != null) {
        field.value = formValues[field.name]
      } else {
        delete field.value
      }
    })

    if (isGlobalSettings) {
      dispatch(toggleElementsDisabled(true))
    }
    await updateContentMutation.mutateAsync(
      {
        accountId,
        userInputForm,
        contentId: content._id,
        forceNer: true,
      },
      {
        onSettled: () => {
          dispatch(toggleElementsDisabled(false))
        },
      }
    )
  }

  const generateVariantsWithoutTopics: FormSubmitAction = async (
    formValues
  ) => {
    // if (!template) {
    //   return
    // }
    // const selectedBrandVoice = formValues.brand_voice as SelectValue | undefined
    // const updatedTemplate = cloneDeep(template)
    // updatedTemplate.user_input_form?.forEach((field) => {
    //   if (formValues[field.name] != null) {
    //     field.value = formValues[field.name]
    //   }
    // })
    // const name = updatedTemplate.user_input_form?.find(
    //   (field) => field.name === 'content_name'
    // )?.value as string | undefined
    // updatedTemplate.name = name || ''
    // await createContentMutation.mutateAsync(
    //   {
    //     accountId,
    //     template: updatedTemplate,
    //     brandVoiceId: selectedBrandVoice?.value,
    //   },
    //   {
    //     onSuccess: (newContent) => {
    //       const elementId = getFirstComponentElement(newContent)?.element_id
    //       if (elementId) {
    //         const wsTopic = getGenerateWsTopic(newContent._id, elementId)
    //         setVariantsLoadingState(queryClient, newContent._id, elementId)
    //         generateVariantsMutation.mutate({
    //           accountId,
    //           wsTopic,
    //           contentId: newContent._id,
    //           elementId,
    //         })
    //         history.replace(`/content/${newContent._id}`)
    //       }
    //     },
    //   }
    // )
  }

  const generateVariants: FormSubmitAction = async (formValues) => {
    // if (!content) {
    //   return
    // }
    // const selectedBrandVoice = formValues.brand_voice as SelectValue | undefined
    // const elementId = getElementIdForGeneration(content, selectedElement)
    // if (elementId) {
    //   const wsTopic = getGenerateWsTopic(content._id, elementId)
    //   setVariantsLoadingState(queryClient, content._id, elementId)
    //   const userInputForm = selectedElement
    //     ? cloneDeep(selectedElement.user_input?.user_input_form)
    //     : undefined
    //   if (userInputForm) {
    //     userInputForm.forEach((field) => {
    //       if (formValues[field.name] != null) {
    //         field.value = formValues[field.name]
    //       } else {
    //         delete field.value
    //       }
    //     })
    //   }
    //   generateVariantsMutation.mutate({
    //     topics: selectedTopics,
    //     accountId,
    //     wsTopic,
    //     contentId: content._id,
    //     elementId,
    //     isCustomSettings: !!selectedElement,
    //     userInputForm,
    //     brandVoiceId: selectedBrandVoice?.value,
    //   })
    // }
  }

  const regenerateVariantsWithoutTopics: FormSubmitAction = async (
    formValues
  ) => {
    if (!content) {
      return
    }

    const selectedBrandVoice = formValues.brand_voice as SelectValue | undefined
    if (
      content.elements.length > 1 &&
      isGlobalSettings &&
      !regenerateModalState.isOpen
    ) {
      setRegenerateModalState({ isOpen: true, formValues })
      return
    }

    const userInputForm = selectedElement
      ? cloneDeep(selectedElement.user_input?.user_input_form)
      : cloneDeep(content.user_input.user_input_form)

    if (userInputForm) {
      userInputForm.forEach((field) => {
        if (formValues[field.name] != null) {
          field.value = formValues[field.name]
        } else {
          delete field.value
        }
      })
    }

    if (isGlobalSettings) {
      dispatch(toggleElementsDisabled(true))
    }

    const elementId = getElementIdForGeneration(content, selectedElement)
    if (elementId) {
      const wsTopic = getGenerateWsTopic(content._id, elementId)

      setVariantsLoadingState(queryClient, content._id, elementId)

      generateVariantsMutation.mutate(
        {
          accountId,
          wsTopic,
          contentId: content._id,
          elementId,
          userInputForm,
          isCustomSettings: !!selectedElement,
          brandVoiceId: selectedBrandVoice?.value,
        },
        {
          onSuccess: () => {
            dispatch(userInputFormHasChanged(false))
          },
        }
      )
    }
  }

  // TODO: remove hardcoded values
  const brief =
    'Bobs breakfast bar has a special offer of 50% off menu items like, full english, eggs benny and other wonderful starts to the day. This offer is on till 6th - 31st Oct from 6am -12pm.'
  const hasTopics = false

  const getState = (): PageState => {
    const hasTopicsChanged = !isEqual(topics, selectedTopics)
    if (hasFormChanged && !shouldUseTopics && hasVariants) {
      return 'formChangedWithoutTopics'
    } else if (hasFormChanged && shouldUseTopics) {
      return 'formChanged'
    } else if (hasTopicsChanged && hasVariants) {
      return 'topicsChanged'
    } else if (!shouldUseTopics && hasVariants) {
      return 'showGeneratedContentWithoutTopics'
    } else if (!shouldUseTopics && !hasVariants) {
      return 'generateWithoutTopics'
    } else if (!hasVariants && brief && !hasTopics) {
      return 'generateTopics'
    } else if (!hasVariants && brief && hasTopics) {
      return 'generateVariants'
    } else if (hasVariants) {
      return 'showGeneratedContent'
    } else {
      return 'generateBrief'
    }
  }

  const state = getState()
  const pageState = state

  useEffect(() => {
    if (
      state === 'topicsChanged' ||
      state === 'formChanged' ||
      state === 'formChangedWithoutTopics'
    ) {
      dispatch(userInputFormHasChanged(true))
    } else {
      dispatch(userInputFormHasChanged(false))
    }
  }, [dispatch, state])

  const parsedConfiguration = parseFieldsConfiguration(userInputForm)
  const generationNoInput = parsedConfiguration?.find(
    (field) => field.name === 'split_num' && field.type === 'dropdown'
  )
  if (
    generationNoInput &&
    (pageState === 'showGeneratedContentWithoutTopics' ||
      pageState === 'showGeneratedContent' ||
      pageState === 'generateBrief')
  ) {
    generationNoInput.isDisabled = true
  }

  const initialValues: any = userInputForm?.reduce(
    (acc, state) => ({ ...acc, [state.name]: state.value }),
    {}
  )

  const updateWorkflowName = (value: string) => {
    if (!content) {
      return
    }

    const userInputForm = cloneDeep(content.user_input.user_input_form)

    userInputForm.forEach((field) => {
      if (field.name === 'workflow_name') {
        field.value = value
      }
    })

    updateContentMutation.mutate(
      {
        contentId: content._id,
        accountId,
        userInputForm,
        updatedName: value,
      },
      {
        onSuccess: () => {
          successToast('Workflow name updated successfully')
        },
      }
    )
  }

  const getSubmitAction = (): FormSubmitAction => {
    switch (pageState) {
      case 'showTemplate':
        return generateTopics
      case 'showTemplateWithoutTopics':
        return generateVariantsWithoutTopics
      case 'formChangedWithoutTopics':
        return regenerateVariantsWithoutTopics
      case 'formChanged':
        return refreshTopics
      case 'generateBrief':
      case 'generateWithoutTopics':
      case 'topicsChanged':
        return generateVariants
      default:
        return async () => {}
    }
  }

  return (
    <div className="flex flex-col flex-1">
      {userInputForm && (
        <Form
          onSubmit={getSubmitAction()}
          initialValues={initialValues}
          render={({ handleSubmit, submitting, dirty }) => (
            <form
              onSubmit={handleSubmit}
              onBlur={(e) => {
                if (
                  e.target.name === 'workflow_name' &&
                  e.target.value !== ''
                ) {
                  updateWorkflowName(e.target.value)
                }
              }}
            >
              <FormSpy
                onChange={(props) => {
                  const dirtyFields = Object.keys(props.dirtyFields)

                  const isDirty =
                    dirtyFields.length > 0 &&
                    !dirtyFields.every((field) => field === 'workflow_name')

                  setHasFormChanged(isDirty)
                }}
              />
              <div className="flex flex-col mb-6 border border-coolGray-300 rounded-md p-6 bg-white">
                <BriefTitle />
                {parsedConfiguration && (
                  <DynamicForm
                    fieldsConfiguration={parsedConfiguration}
                    isDisabled={submitting}
                    pageState={state}
                    isGeneratingVariants={generateVariantsMutation.isLoading}
                  />
                )}
              </div>
              <GeneratedBrief brief={brief} pageState={state} />
              <GeneratedTopics
                topics={selectedTopics}
                pageState={state}
                setSelectedTopics={setSelectedTopics}
              />
              <ActionButtons
                pageState={state}
                topics={topics ?? []}
                revertTopics={revertTopics}
                isCreatingContent={false} // TODO: Fix this prop
                // isCreatingContent={createContentMutation.isLoading}
                isUpdatingContent={updateContentMutation.isLoading}
                isGeneratingVariants={generateVariantsMutation.isLoading}
              />
              <RouterPromptStay
                shouldShow={!!content && dirty && !submitting}
                onOK={() => Promise.resolve(true)}
              />
            </form>
          )}
        />
      )}
      <FormLeaveModal />
      <RegenerateModal
        isOpen={regenerateModalState.isOpen}
        onConfirm={() => {
          if (regenerateModalState.formValues) {
            regenerateVariantsWithoutTopics(regenerateModalState.formValues)
            setRegenerateModalState({ isOpen: false })
          }
        }}
        onClose={() => setRegenerateModalState({ isOpen: false })}
      />
    </div>
  )
}

export default BriefPage
